import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Building up the whole picture',
    paragraph: 'Company has been working on builing up a picture for you by working in different fields to provide you with the best experience and enviroment possible.'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Drones and Technologies
                  </div>
                <h3 className="mt-0 mb-12">
                Revolutionizing Farming
                  </h3>
                <p className="m-0">
                There is a greater need than ever before for farmers and agronomists across the globe to improve resource management in response to tightening budgets, while the “farm to fork” movement has seen rising pressure for enhanced product traceability, as consumers become more interested in the origin of the goods they purchase and how they were grown.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/WhatsApp Image 2021-09-20 at 3.14.56 PM.jpeg')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Data-driven insights
                  </div>
                <h3 className="mt-0 mb-12">
                  Digital Marketing
                  </h3>
                <p className="m-0">
                For all the digital marketing services we have professional and hard-working teams. Dedicated teams work on specific tasks to ensure guaranteed improvements in client’s online business. We take care of almost everything related to the client’s requirement.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/internet-marketing-1802610_1280.png')}
                  alt="Features split 02"
                  width={528}
                  height={396} />
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Medical insights
                  </div>
                <h3 className="mt-0 mb-12">
                  Life Science and healthcare
                  </h3>
                <p className="m-0">
                with the use of Technology and Use of Machine Learning  to Reduce Readmission Rates we are dedicated to bring transformation in Healthcare ,Enhanced Security to Protect Your Sensitive Patient Data,Reduced Time Spent on Administrative Tasks to Increase Quality Care, Streamlined Communication Between Departments, Improved Efficiency of Supply Chain to Increase Your Control over Spend,Faster, More Accurate Diagnoses to Save More Lives, Minimized Patient No-Shows and Enhanced Follow-Up Care
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/WhatsApp Image 2021-09-21 at 11.13.52 PM.jpeg')}
                  alt="Features split 03"
                  width={528}
                  height={396} />
              </div>
            </div>
            

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Protection 
                  </div>
                <h3 className="mt-0 mb-12">
                Compliance Audit and Security Services
                  </h3>
                <p className="m-0">
                At Clic, we deal with cyber security 24x7. We provide complete spectrum of services that any organisation will need.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/WhatsApp Image 2021-09-21 at 11.16.15 PM.jpeg')}
                  alt="Features split 02"
                  width={528}
                  height={396} />
              </div>
            </div> <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Minimize manual labour
                  </div>
                <h3 className="mt-0 mb-12">
                Intelligent Automation Services
                  </h3>
                <p className="m-0">
                with the help of automation Using Deep Learning for Sentiment Analysis and Opinion Mining Gauging opinions is faster and more accurate with deep learning technologies.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/technology-3393230_1280.jpg')}
                  alt="Features split 0"
                  width={528}
                  height={396} />
              </div>
            </div>
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Legal services
                  </div>
                <h3 className="mt-0 mb-12">
                Legal ,Tax and Compliance Services
                  </h3>
                <p className="m-0">
                whether  Shops and Establishments registration or Company registration or Trademarks or Easy tax Registration and filing  we have it all...you get it in the least possible time.
Services starts with as low as ₹900/-
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/WhatsApp Image 2021-09-22 at 8.55.27 PM.jpeg')}
                  alt="Features split 02"
                  width={528}
                  height={396} />
              </div>
            </div> 
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                Minimize manual labour
                  </div>
                <h3 className="mt-0 mb-12">
                Billing and ERP Softwares
                  </h3>
                <p className="m-0">
                It is crucially important to reduce inventory costs and eliminate waste. Starting from billing to CRM softwares we have it all

Price starts from 6000/-.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/WhatsApp Image 2021-09-22 at 8.57.25 PM.jpeg')}
                  alt="Features split 0"
                  width={528}
                  height={396} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;